import { useFeatureVariation } from 'plugins/optimizely/hooks/use-feature-variation';
import { IMMEDIATE_FEATURES } from 'utils/experiment';
// Audience for this AB test is:
// - Mobile Web
// - Parking Type: transient, monthly, event, power_booking
export const useMobileWebRelevanceVariation = () => {
    const variation = useFeatureVariation(IMMEDIATE_FEATURES.ACQUISITION_MOBILE_WEB_MAP_RELEVANCE_BOOK_NOW);
    return {
        enabled: variation !== 'off',
        variation,
        isOriginal: variation === 'original',
        isVariation1: variation === 'variant_1',
        isVariation2: variation === 'variant_2',
    };
};
